export default __webpack_public_path__ + "img/dHeVdGKV.3e48f834.svg";